
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import { Route } from "vue-router";
import { DataType } from "@/views-desktop/@types/filter-page.d";
import { mapGetters, mapMutations, mapState } from "vuex";
import PlaceCategoryMixin2 from "@/mixins/place-category2";
import { parameterizedURLQuery } from "@/mixins/common-functions";
import { hasAccessToken } from "@/mixins/common-functions";
// components
import GenreBtn from "@/components/genre-place-category/place-category-genre-btn.vue";
import GenreBody from "@/components/genre-place-category/place-category-body2.vue";
import FilterHeader from "@/components/filters/filter-header.vue";
import FilterSearchBar from "@/components/filters/filter-search-bar.vue";
import VButton from "@/components/common/button.vue";
import IosDummy from "@/layouts/layout-ios-dummy.vue";

export default PlaceCategoryMixin2.extend({
  name: "view-filter-page",
  mixins: [PlaceCategoryMixin2],
  components: {
    GenreBtn,
    IosDummy,
    GenreBody,
    FilterHeader,
    FilterSearchBar,
    VButton,
  },
  props: {
    isMobile: Boolean,
    isModal: Boolean,
    blackLayoutClicked: Boolean,
    hideAreaBar: Boolean,
  },
  data(): DataType {
    return {
      prevRoute: undefined,
      tmpSelectedTopPlace: undefined,
      previousSelectedGenre: undefined,
      previousSelectedGenreCategoryList: undefined,
      previousSelectedFilterRadioButtons: undefined,
      tmpSelectedCountry: "jp",
      gpsButtonStatus: "normal",
    };
  },
  watch: {
    blackLayoutClicked(flag: boolean) {
      if (flag) {
        this.closedFilterPanel({ apply: false });
      }
    },
    hasCurrentLocation(newVal?: boolean) {
      console.log(`hasCurrentLocation: ${newVal}`);
      this.gpsButtonStatus = newVal === undefined || newVal === true ? "normal" : "error";
      if (this.gpsButtonStatus === "error") {
        this.setShowDenyGpsAlertView(true);
        this.handleListScroll();
      }
      // update UI and search
      setTimeout(() => {
        if (newVal === true) {
          this.searchWithCurrentLocation();
        }
      }, 1000);
    },
  },
  computed: {
    ...mapState("data", [
      "selectedTopPlace",
      "selectedGenre",
      "selectedCountry",
      "selectedGenreCategoryList",
      "isFirstSearch",
      "location",
      "hasCurrentLocation",
    ]),
    ...mapState("data", {
      currentLocation: "location",
    }),
    ...mapState("ui", ["isAreaViewModal"]),
    ...mapGetters("data", ["isNotNormalMap"]),
    congestionImgSrc(): string {
      return require("@/assets/images/congestion.svg");
    },
    favoriteImgSrc(): string {
      return require("@/assets/images/favorite.svg");
    },
    showAreaSearch(): boolean {
      return !["disaster-prevention"].includes(this.selectedGenre);
    },
    showStatusFilter(): boolean {
      return !["disaster-prevention"].includes(this.selectedGenre);
    },
    showVacantMask(): boolean {
      console.log(`showVacantMask: ${JSON.stringify(this.selectedFilterRadioButtons)} `);
      if (!this.selectedFilterRadioButtons) return false;
      const flag: string | undefined = this.selectedFilterRadioButtons.find((btnName: string) => btnName === "vacant");
      return flag !== undefined;
    },
    showFavoriteMask(): boolean {
      if (!this.selectedFilterRadioButtons) return false;
      const flag: string | undefined = this.selectedFilterRadioButtons.find(
        (btnName: string) => btnName === "favorite",
      );
      return flag !== undefined;
    },
    getApplyBtnStatus(): string {
      return this.gpsButtonStatus === "error" ? "normal" : this.gpsButtonStatus;
    },
    disableApplyBtn(): boolean {
      return this.gpsButtonStatus === "loading" || this.gpsButtonStatus === "error";
    },
  },
  created() {
    this.previousSelectedGenre = this.selectedGenre;
    this.tmpSelectedTopPlace = { ...this.selectedTopPlace };
    this.previousSelectedFilterRadioButtons = [...this.selectedFilterRadioButtons];
    // ...undefined is not allowed
    this.previousSelectedGenreCategoryList =
      this.selectedGenreCategoryList !== undefined ? [...this.selectedGenreCategoryList] : [];
    // default state
    if (this.isFirstSearch) {
      this.setTmpSelectedTopPlace({
        areaName: "current-place",
        displayText: this.$i18n.t("Nav.gpsBtn.title") as string,
        location: this.location,
        displayOrder: 1,
      });
    }
  },
  methods: {
    ...mapMutations("data", [
      "setSelectedGenre",
      "setSelectedGenreCategoryList",
      "setSelectedFilterRadioButtons",
      "setSelectedCountry",
      "setSelectedTopPlace",
    ]),
    ...mapMutations("ui", ["setShowDenyGpsAlertView"]),
    setTmpSelectedTopPlace(area?: PortalAdapterApi.TopArea) {
      this.tmpSelectedTopPlace = area;
      this.tmpSelectedCountry = this.selectedCountry;
      this.gpsButtonStatus = "normal";
      if (this.hasCurrentLocation === false && area?.areaName === "current-place") {
        this.gpsButtonStatus = "error";
      }
    },
    searchWithCurrentLocation() {
      this.setSelectedTopPlace({
        areaName: "current-place",
        displayText: this.$i18n.t("Nav.gpsBtn.title") as string,
        location: this.currentLocation,
        displayOrder: 1,
      });
      this.$router.push(`/map/${this.currentLocation.lat},${this.currentLocation.lng}`).catch(() => {
        console.warn("router cannot be pushed");
      });
      this.closedFilterPanel({ apply: true });
    },
    checkGPSLocation() {
      this.$store.dispatch("data/checkGeolocation");
    },
    applyClicked() {
      const query = this.getFilterQueries();
      const stringifyQuery = parameterizedURLQuery(query);
      console.log(`filter page apply clicked: ${stringifyQuery}`);
      if (this.tmpSelectedTopPlace !== undefined) {
        if (this.tmpSelectedTopPlace.areaName === "current-place") {
          if (this.hasCurrentLocation === undefined) {
            this.gpsButtonStatus = "loading";
          } else if (this.hasCurrentLocation === false) {
            this.gpsButtonStatus = "error";
            this.setShowDenyGpsAlertView(true);
            this.handleListScroll();
          } else {
            if (this.currentLocation.lat !== undefined) {
              this.searchWithCurrentLocation();
              return;
            }
          }
          this.checkGPSLocation();
          return;
        }
        this.$router
          .push(`/area/${this.tmpSelectedTopPlace?.areaName}?${stringifyQuery}`)
          .catch(() => console.error(`push filter page failed`));
      } else {
        this.$router
          .push(`/area/${this.selectedTopPlace?.areaName}?${stringifyQuery}`)
          .catch(() => console.error(`push filter page failed`));
      }
      this.closedFilterPanel({ apply: true });
    },
    clearClicked() {
      if (!this.isNotNormalMap) {
        this.setSelectedGenre(undefined);
      }
      this.setSelectedGenreCategoryList([]);
      this.setSelectedFilterRadioButtons([]);
      this.gpsButtonStatus = "normal";
    },
    genreBtnClicked(radioName: string) {
      if (!this.selectedFilterRadioButtons) return;
      const flag: boolean = radioName === "vacant" ? this.showVacantMask : this.showFavoriteMask;
      console.log("genreBtnClicked:", flag);
      // flag is to present which btn user clicked, not selected state
      if (radioName === "favorite" && !hasAccessToken()) {
        return this.$store.commit("ui/setFavoritePrompt", true);
      }

      if (flag) {
        const index: number = this.selectedFilterRadioButtons.findIndex((category: string) => category === radioName);
        console.log(`index = ${index}`);
        // remove
        if (index >= 0) {
          this.selectedFilterRadioButtons.splice(index, 1);
        }
      } else {
        const list = this.selectedFilterRadioButtons;
        list.push(radioName);
      }
    },
    radioClicked({ radioName, flag }: { radioName: string; flag: boolean }) {
      // flag is to present which btn user clicked, not selected state
      if (flag && radioName === "favorite" && !hasAccessToken()) {
        return this.$store.commit("ui/setFavoritePrompt", true);
      }

      if (!flag && this.hasSelectedFilter(radioName)) {
        const index: number = this.selectedFilterRadioButtons.findIndex((category: string) => category === radioName);
        // remove
        if (index >= 0) {
          this.selectedFilterRadioButtons.splice(index, 1);
        }
      } else {
        const list = this.selectedFilterRadioButtons;
        list.push(radioName);
        this.setSelectedFilterRadioButtons(list);
      }
    },
    closedFilterPanel(flag: { apply: boolean }) {
      console.log(`--- closedFilterPanel flag: ${flag.apply}`);
      // put back previous data if no applying
      if (!flag || !flag.apply) {
        this.setSelectedFilterRadioButtons(this.previousSelectedFilterRadioButtons);
        this.setSelectedGenre(this.previousSelectedGenre);
        this.setSelectedCountry(this.tmpSelectedCountry);
        this.setSelectedGenreCategoryList(this.previousSelectedGenreCategoryList);
      }
      this.$emit("close-filter-panel");
    },
    // scroll-top on gps-error
    handleListScroll() {
      const list: HTMLElement | null = document.querySelector(".filter-page");
      if (list === null) return;
      list.scrollTop = 0;
    },
  },
  // router
  beforeRouteEnter(_: Route, from: Route, next) {
    next((vm: any) => {
      vm.prevRoute = from;
    });
  },
});
